import { Component } from '@angular/core';

interface GovernanceKpi {
  label: string;
  value: string;
  trend: string;
  direction: 'up' | 'down';
  icon: string;
  tone: string;
}

@Component({
  selector: 'pm-quality-governance',
  templateUrl: './quality-governance.component.html',
  styleUrls: ['./quality-governance.component.css']
})
export class QualityGovernanceComponent {
  dateRange = 'Jan 01, 2024 - Mar 31, 2024';
  selectedClient = 'All Clients';
  selectedProject = 'All Projects';
  selectedAuditorGroup = 'All Auditor Groups';
  selectedFormType = 'All Form Types';

  kpis: GovernanceKpi[] = [
    { label: 'Total Audits', value: '428', trend: '12%', direction: 'up', icon: 'fa-regular fa-file-lines', tone: 'orange' },
    { label: 'Overall Quality Score', value: '92.4%', trend: '2.8%', direction: 'up', icon: 'fa-regular fa-star', tone: 'blue' },
    { label: 'Open Findings', value: '36', trend: '18%', direction: 'down', icon: 'fa-regular fa-file', tone: 'green' },
    { label: 'Critical Findings', value: '8', trend: '33%', direction: 'down', icon: 'fa-solid fa-triangle-exclamation', tone: 'red' },
    { label: 'Average TAT', value: '2h 18m', trend: '26%', direction: 'down', icon: 'fa-regular fa-clock', tone: 'purple' },
    { label: 'Repository Publish Rate', value: '96.7%', trend: '3.1%', direction: 'up', icon: 'fa-solid fa-database', tone: 'green' }
  ];

  findingsByCategory = [
    { label: 'Maximum & Deductible', value: 48 },
    { label: 'Coverage & Frequency', value: 34 },
    { label: 'Co-Insurance', value: 26 },
    { label: 'Insurance', value: 19 },
    { label: 'Patient / Subscriber', value: 14 },
    { label: 'Ortho', value: 9 },
    { label: 'History / Remarks', value: 6 }
  ];

  projectRankings = [
    { project: 'Guardian Dentistry', client: 'Guardian Dentistry', audits: 92, score: '96.8%', open: 4, critical: 1 },
    { project: 'DAG', client: 'DAG Dental', audits: 78, score: '94.2%', open: 6, critical: 1 },
    { project: 'HQRC', client: 'HQRC', audits: 71, score: '92.1%', open: 8, critical: 2 },
    { project: 'Frontline', client: 'Frontline Dental', audits: 65, score: '89.4%', open: 10, critical: 3 },
    { project: 'Jenkins', client: 'Jenkins Dental', audits: 54, score: '87.6%', open: 12, critical: 1 }
  ];

  auditorPerformance = [
    { auditor: 'Priya Nair', group: 'Internal', audits: 86, score: '96.3%', findings: 6, rework: '2.3%' },
    { auditor: 'Arjun Mehta', group: 'Internal', audits: 78, score: '93.8%', findings: 8, rework: '3.1%' },
    { auditor: 'Neha Kapoor', group: 'External', audits: 64, score: '91.5%', findings: 10, rework: '4.6%' },
    { auditor: 'Rahul Singh', group: 'Internal', audits: 58, score: '89.2%', findings: 14, rework: '6.8%' },
    { auditor: 'Kavya Nair', group: 'External', audits: 52, score: '87.6%', findings: 16, rework: '7.4%' }
  ];

  trendPoints = [80, 81, 82, 85, 87, 88, 88, 89, 90, 90, 91, 91, 92, 94];

  getCategoryWidth(value: number): number {
    return Math.max(8, Math.round((value / 48) * 100));
  }
}
